// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import shim from 'promise.prototype.finally'
import VTooltip from 'v-tooltip'
import VueClipboard from 'vue-clipboard2'

import fontawesome from '@fortawesome/fontawesome'
import faCopy from '@fortawesome/fontawesome-free-regular/faCopy'
import faSpinner from '@fortawesome/fontawesome-free-solid/faSpinner'

import './assets/bootstrap/reboot.scss'

fontawesome.library.add(
  faCopy,
  faSpinner
)

Vue.config.productionTip = false

if (typeof Promise.prototype.finally === 'undefined') {
  shim()
}

Vue.use(VTooltip)
Vue.use(VueClipboard)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js